<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Laporan Transaksi iBayaq Mengikut Jenis Bayaran">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <!-- <z-lookup
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        /> -->
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;max-height: 500px;">
                    <table class="table-dashboard" style="width:100%;">
                        <thead>
                            <tr>
                                <td>BIL</td>
                                <td>TARIKH</td>
                                <td>NO. RESIT</td>
                                <td>NO. RUJUKAN</td>
                                <td>NAMA</td>
                                <td>CARA BAYARAN</td>
                                <td>NO. TRANSAKSI</td>
                                <td>AMAUN (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <template v-for="(dt, index) in table.items">
                                    <tr>
                                        <td colspan="8"><b>{{ dt.keterangan }}</b></td>
                                    </tr>
                                    <tr v-for="(resit,idx) in dt.resits">
                                        <td>{{ idx +1 }}</td>
                                        <td>{{ resit.tarikh_bayar }}</td>
                                        <td>{{ resit.no_resit }}</td>
                                        <td>{{ resit.no_rujukan }}</td>
                                        <td>{{ resit.pemilik_nama }}</td>
                                        <td>{{ resit.cara_terimaan_keterangan }}</td>
                                        <td>{{ resit.no_dokumen }}</td>
                                        <td style="text-align: right;">{{ resit.amaun }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="7"><b>JUMLAH</b></td>
                                        <td style="text-align: right"><b>{{dt.amaun_jumlah}}</b></td>
                                    </tr>
                                </template>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="8" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="7"><b>JUMLAH KESELURUHAN</b></td>
                                <td style="text-align: right"><b>{{table.jumlah_total}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card> -->
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" id="cetak" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_ibayaq + "laporan/ibayaq_jenis_bayaran",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/ibayaq_trans_jenis_bayaran"},
                { label: "Laporan", route: "/kutipan/laporan/ibayaq_trans_jenis_bayaran"},
                {
                    label: "Laporan Transaksi iBayaq Mengikut Jenis Bayaran",
                    route: "/kutipan/laporan/ibayaq_trans_jenis_bayaran",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("kutipan.laporan.ibayaq_trans_jenis_bayaran") + 
                    "?tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga+
                    "&jabatan_id=" + this.cari.jabatan_id,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            document.getElementById("cetak").disabled = true;
            window.open(this.service_ibayaq+'laporan/ibayaq_jenis_bayaran/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&jabatan_id=" + this.cari.jabatan_id,'_blank');
            },
        },
        watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        // console.log(this.auth.user.id);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
